import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import { SecurityAuthenticationComponent } from './security-authentication.component';
import { ChangeAuthenticationAlertComponent } from './modal-actions/security-authentication-change.component';
import { PendingChangesAuthenticationAlertComponent } from './modal-actions/security-authentication-pendingchanges.component';
import { SelectedOptionsFilter } from './selected-options.filter';
import { FileExtensionAlertComponent } from './modal-actions/security-authentication-file-extension.component';

import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

// shared components
import { SharedModule } from './../../shared/shared.module';
import { BzTabModule } from './../../shared/components/tab/tab.module';
import { BzSwitchModule } from '../../shared/components/switch/switch.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BzTreeModule } from '../../shared/components/tree/tree.module';
import { SecurityAuthListComponent } from './security-auth-list/security-auth-list.component';
import { SecurityAuthDetailComponent } from './security-auth-detail/security-auth-detail.component';
import { MultipleAuthListComponent } from './multiple-auth-list/multiple-auth-list.component';
import { MultipleAuthDetailComponent } from './multiple-auth-detail/multiple-auth-detail.component';
import { StoreModule } from '@ngrx/store';
import { SECURITY_AUTHENTICATION_REDUCER } from './core/security-auth-feature.reducers';
import { PendingChangesMultiAuthService } from './core/pending-changes.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [
    SecurityAuthenticationComponent,
    ChangeAuthenticationAlertComponent,
    PendingChangesAuthenticationAlertComponent,
    SelectedOptionsFilter,
    FileExtensionAlertComponent,
    SecurityAuthListComponent,
    SecurityAuthDetailComponent,
    MultipleAuthListComponent,
    MultipleAuthDetailComponent
  ],
  imports: [
    BrowserAnimationsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    StoreModule.forFeature('securityAuth', SECURITY_AUTHENTICATION_REDUCER),
    CommonModule,
    BrowserModule,
    FormsModule,
    BzTabModule,
    BzSwitchModule,
    AccordionModule,
    BzTreeModule,
    SharedModule
  ],
  exports: [
    SecurityAuthenticationComponent,
    ChangeAuthenticationAlertComponent,
    PendingChangesAuthenticationAlertComponent,
    SelectedOptionsFilter,
    FileExtensionAlertComponent
  ],
  providers:[PendingChangesMultiAuthService]
})
export class SecurityAuthenticationModule {}
